export default (state = '') => state

export * from './selector'
